import { useRef, useState } from 'react';
import Card from './ui/Card';
const Carousel = ({ content, renderItem }) => {
    const [currItem, setCurrItem] = useState(0);
    const items = useRef(content || []);
    const card = useRef(null);

    const onChangeItem = type => {
        if (type === 'forward') {
            setCurrItem(currItem === items.current.length - 1 ? 0 : currItem + 1);
        } else {
            setCurrItem(currItem === 0 ? items.current.length - 1 : currItem - 1);
        }
    };

    const thisItem = items.current[currItem];

    return (
        <div ref={card} className="carousel-card">
            <Card showContent={false}>
                <button onClick={() => onChangeItem('forward')}>{'<'}</button>
                <div className="testimonials-wrapper" key={currItem}>
                    {renderItem(thisItem)}
                </div>
                <button onClick={() => onChangeItem('back')}>{'>'}</button>
            </Card>
        </div>
    );
};

export default Carousel;
